import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getSummaryPopup, getUserPopup } from "../redux/actions";
import { UserPopup } from "./popups/UserPopup";
import { SummaryPopup } from "./popups/SummaryPopup";
import { ID, NAME, COMMENTS, MESSAGES, TOTAL } from "../utils/userConsts"

export const TopTable = () => {
    const dispatch = useDispatch()
    const id = useSelector(state => state.user.id)
    const list = useSelector(state => state.table.list)
    const searchedUser = useSelector(state => state.table.searchedUser)
    const lang = useSelector(state => state.app.currentLang)
    const searchItems = useSelector(state => state.table.searchItems)
    const summary = useSelector(state => state.table.summary)
    let n = 0;

    if (!Array.isArray(list) || list.length === 0) {
        return null
    }
    return (
        <React.Fragment>
            <div className={'topTable ' + (searchItems.length > 0 ? 'searched' : '')}>
                <div className="topTable__table">
                    <div className="topTable__thead">
                        <div className="topTable__tr">
                            <div className="topTable__th">
                                <span>№</span>
                            </div>
                            <div className="topTable__th">
                                <span>{lang.table1}</span>
                            </div>
                            <div className="topTable__th">
                                <div className="topTable__icon1"></div>
                            </div>
                            <div className="topTable__th">
                                <div className="topTable__icon2"></div>
                            </div>
                            <div className="topTable__th">
                                <div className="topTable__icon3"></div>
                            </div>
                            <div className="topTable__th">
                                <div className="topTable__icon4"></div>
                            </div>
                        </div>
                    </div>
                    <div className="topTable__thead">
                        {
                          summary !== null && (
                                <div className="topTable__tr ">
                                    <div className="topTable__td">0</div>
                                    <div className="topTable__td">{lang.table3}</div>
                                    <div className="topTable__td">{summary.comments}</div>
                                    <div className="topTable__td">{summary.messages}</div>
                                    <div className="topTable__td">{summary.points}</div>
                                    <div className="topTable__td ">
                                        <div className="topTable__icon5"
                                            onClick={() => dispatch(getSummaryPopup())}></div>
                                    </div>
                                </div>
                            )
                        }
                        {
                          searchedUser.id > 0 && searchedUser.name.length > 0 && (
                                <div className="topTable__tr ">
                                    <div className="topTable__td marked">-</div>
                                    <div className="topTable__td marked">{searchedUser.name}</div>
                                    <div className="topTable__td marked">{searchedUser.comments}</div>
                                    <div className="topTable__td marked">{searchedUser.messages}</div>
                                    <div className="topTable__td marked">{searchedUser.total}</div>
                                    <div className="topTable__td marked">
                                        <div className="topTable__icon5"
                                            onClick={() => dispatch(getUserPopup(id, searchedUser.id, searchedUser.name))}></div>
                                    </div>
                                </div>
                            )
                        }
                        {
                           list.filter((item) => {
                                if (!(item[ID] ?? false) || !(item[NAME] ?? false)) {
                                    return false
                                } else return true
                            }).map((item) => {
                                    n++;
                                return (
                                    <div className="topTable__tr" key={item[ID]}>
                                        <div className="topTable__td">
                                            {
                                                n
                                            }
                                        </div>
                                        <div className="topTable__td">
                                            {
                                                item[NAME]
                                            }
                                        </div>
                                        <div className="topTable__td">
                                            {
                                                item[COMMENTS] ?? 0
                                            }
                                        </div>
                                        <div className="topTable__td">
                                            {
                                                item[MESSAGES] ?? 0
                                            }
                                        </div>
                                        <div className="topTable__td">
                                            {
                                                item[TOTAL] ?? 0
                                            }
                                        </div>
                                        <div className="topTable__td">
                                            <div className="topTable__icon5"
                                                onClick={() => dispatch(getUserPopup(id, item[ID], item[NAME]))}></div>
                                        </div>
                                    </div>)
                            })
                        }
                    </div>
                </div>
            </div>
            <UserPopup />
           <SummaryPopup />
        </React.Fragment>

    )
}